import { SUI } from 'shared/ui'
import RoomList from 'subapps/chat/components/RoomList'
import RoomListHeader from 'subapps/chat/components/RoomList/Header'
import styles from './styles.less'

export default function RoomListWithHeader() {
  return (
    <SUI transparent className={styles.roomListAndHeaderContainer}>
      <RoomListHeader />
      <RoomList />
    </SUI>
  )
}
